import React from 'react';
import { Result } from 'antd';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AccessDenied = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-3);
    };

    return (
        <Result
            status="403"
            title="403"
            subTitle="Access Denied"
            extra={
                <Button type="primary" variant="contained" onClick={handleBack}>
                    Go Back
                </Button>
            }
        />
    );
};

export default AccessDenied;
